var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("应用管理")]),
      _vm._v(" "),
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          {
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleSearch($event)
              },
            },
          },
          [
            _c("el-input", {
              attrs: { placeholder: "输入应用名称搜索", clearable: "" },
              model: {
                value: _vm.queryParams.configName,
                callback: function ($$v) {
                  _vm.$set(_vm.queryParams, "configName", $$v)
                },
                expression: "queryParams.configName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                attrs: { type: "info", plain: "" },
                on: { click: _vm.handleReset },
              },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                attrs: { type: "primary" },
                on: { click: _vm.handleAdd },
              },
              [_vm._v("新增配置")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "configName",
                  label: "应用名称",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appId",
                  label: "App ID",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appKey",
                  label: "App Key",
                  "min-width": "200",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appSecret",
                  label: "App Secret",
                  "min-width": "160",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.maskSecret(row.appSecret)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-switch", {
                          attrs: {
                            value: row.status === 1,
                            "active-color": "#13ce66",
                          },
                          on: {
                            change: function (val) {
                              return _vm.handleStatusChange(row, val)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "备注",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.remark || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  fixed: "right",
                  align: "center",
                  width: "280",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c(
                            "div",
                            {
                              staticClass: "Operation_button",
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetail(row)
                                },
                              },
                            },
                            [_vm._v("应用详情")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "Operation_button ml10",
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "del_button ml10",
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isAdd ? "新增配置" : "编辑配置",
            visible: _vm.editDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialogVisible = $event
            },
            close: _vm.resetEditForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                model: _vm.editForm,
                rules: _vm.editRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "应用名称", prop: "configName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入应用名称" },
                    model: {
                      value: _vm.editForm.configName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "configName", $$v)
                      },
                      expression: "editForm.configName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.editForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "status", $$v)
                        },
                        expression: "editForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入备注" },
                    model: {
                      value: _vm.editForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "remark", $$v)
                      },
                      expression: "editForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.editLoading },
                  on: { click: _vm.submitEditForm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "应用详情",
            visible: _vm.detailDialogVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
            close: function ($event) {
              _vm.secretVisible = false
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "110px" } },
            [
              _c("el-form-item", { attrs: { label: "应用名称" } }, [
                _c("span", [_vm._v(_vm._s(_vm.detailData.configName || "-"))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "App ID" } }, [
                _c("span", [_vm._v(_vm._s(_vm.detailData.appId || "-"))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "App Key" } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "detail-field" }, [
                      _vm._v(_vm._s(_vm.detailData.appKey)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml10",
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.copyText(_vm.detailData.appKey)
                          },
                        },
                      },
                      [_vm._v("复制")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "App Secret" } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "div",
                      { staticClass: "detail-field" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.secretVisible
                                ? _vm.detailData.appSecret
                                : _vm.maskSecret(_vm.detailData.appSecret)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { padding: "0", "margin-left": "8px" },
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                _vm.secretVisible = !_vm.secretVisible
                              },
                            },
                          },
                          [
                            _c("svg-icon", {
                              attrs: {
                                "icon-class": _vm.secretVisible
                                  ? "eye-open"
                                  : "eye",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml10",
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.copyText(_vm.detailData.appSecret)
                          },
                        },
                      },
                      [_vm._v("复制")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml4",
                        attrs: { size: "small", type: "danger" },
                        on: { click: _vm.handleResetSecret },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "备注" } }, [
                _c("span", [_vm._v(_vm._s(_vm.detailData.remark || "-"))]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }